import { useCallback, useState } from 'react';

export type DashboardRangePreset = 'all' | '1W' | '1M' | '3M' | '6M' | '1Y' | 'custom';

const DEFAULT_PRESET: DashboardRangePreset = 'all';

export const usePlayersDashboardFilters = () => {
  const [rangePreset, setRangePreset] = useState<DashboardRangePreset>(DEFAULT_PRESET);
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);

  const handlePresetChange = useCallback((preset: DashboardRangePreset) => {
    setRangePreset(preset);
    if (preset !== 'custom') {
      setStartDate(null);
      setEndDate(null);
    }
  }, []);

  const handleDatesChange = useCallback((start: Date | null, end: Date | null) => {
    setStartDate(start);
    setEndDate(end);
    if (start || end) {
      setRangePreset('custom');
    }
  }, []);

  return {
    rangePreset,
    startDate,
    endDate,
    setRangePreset: handlePresetChange,
    setDates: handleDatesChange,
  };
};

